import { render, staticRenderFns } from "./weeklyList.vue?vue&type=template&id=6a9a70d2&scoped=true&"
import script from "./weeklyList.vue?vue&type=script&lang=js&"
export * from "./weeklyList.vue?vue&type=script&lang=js&"
import style0 from "./weeklyList.vue?vue&type=style&index=0&id=6a9a70d2&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a9a70d2",
  null
  
)

export default component.exports